var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImagesSolid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 576 512",
    style: {
      enableBackground: "new 0 0 576 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M160,32c-35.3,0-64,28.7-64,64v224c0,35.3,28.7,64,64,64h352c35.3,0,64-28.7,64-64V96c0-35.3-28.7-64-64-64H160 z M396,138.7l96,144c4.9,7.4,5.4,16.8,1.2,24.6S480.9,320,472,320H328h-48h-80c-9.2,0-17.6-5.3-21.6-13.6s-2.9-18.2,2.9-25.4l64-80 c4.6-5.7,11.4-9,18.7-9s14.2,3.3,18.7,9l17.3,21.6l56-84c4.5-6.6,12-10.6,20-10.6S391.5,132,396,138.7z M192,128 c0-17.7,14.3-32,32-32s32,14.3,32,32s-14.3,32-32,32S192,145.7,192,128z M48,120c0-13.3-10.7-24-24-24S0,106.7,0,120v224 c0,75.1,60.9,136,136,136h320c13.3,0,24-10.7,24-24s-10.7-24-24-24H136c-48.6,0-88-39.4-88-88V120z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImagesSolid);
export default __webpack_public_path__ + "static/media/images-solid.8fa00ef78ed78c3c4f0cdbb8609b017a.svg";
export { ForwardRef as ReactComponent };